import { render, staticRenderFns } from "./fileRecord.vue?vue&type=template&id=963f0958&"
import script from "./fileRecord.vue?vue&type=script&lang=js&"
export * from "./fileRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports